namespace Umbrella {
    @Pipe('Umbrella', 'apiUrl')
    class ApiUrlFilter {
        public transform(relativeUrl: string) {
            return Config.makeAbsoluteApiUrl(relativeUrl);
        }
    }
}
